import { ArrowRight, CircleDot } from 'lucide-react';
import { Link } from 'react-router-dom';

import usePageMetadata from '../../hooks/usePageMetadata';
import './ThreadsHome.css';

const ThreadsHome = () => {
  usePageMetadata(
    'Thread Calculators for Machining | ASiJoLab',
    'Explore Metric M thread sizes, tolerance classes and calculated thread limits for internal and external threads.',
    { canonical: 'https://asijolab.com/threads', robots: 'index, follow' }
  );

  return (
    <main className="threadsHome">
      <header className="threadsHomeIntro">
        <p>Thread calculation tools</p>
        <h1>Threads</h1>
        <span>Choose a thread family to explore available sizes and calculate dimensional limits.</span>
      </header>

      <section className="threadsFamilies" aria-labelledby="thread-families-title">
        <div>
          <p>Available now</p>
          <h2 id="thread-families-title">Thread families</h2>
        </div>
        <Link className="threadsFamilyCard" to="/threads/metric">
          <span className="threadsFamilyIcon" aria-hidden="true"><CircleDot size={28} strokeWidth={1.9} /></span>
          <span className="threadsFamilyCopy">
            <strong>Metric M</strong>
            <span>ISO metric thread dimensions and tolerance calculations for internal and external threads.</span>
          </span>
          <span className="threadsFamilyAction">Open Metric M <ArrowRight size={18} aria-hidden="true" /></span>
        </Link>
      </section>
    </main>
  );
};

export default ThreadsHome;
